import React from "react";
import { FileTextIcon } from "assets";
import { UTILITY_BILL_PAGE as ROUTE_UTILITY_BILL_PAGE } from "./route-consts";

export const UTILITY_BILLS_PAGE = {
  ABSOLUTE_PATH: "/documents/summary",
  PATH: "summary/*",
  TITLE: "Document summary",
  ICON: <FileTextIcon />,
};

export const UTILITY_BILL_PAGE = ROUTE_UTILITY_BILL_PAGE;

export const UTILITY_BILLS_TABLE = {
  COLUMN_TO_SORT_COLUMN_MAP: {
    amount: "COST",
    co2Emission: "EMISSIONS",
    endDate: "END_DATE",
    startDate: "START_DATE",
    measuredValue: "USAGE",
  },
  INITIAL_SORTING_STATE: [{ id: "startDate", desc: true }],
  ROWS_PER_PAGE_OPTIONS: [100, 200, 500, 1000],
};

// Filter query params accepted by GET /recalculation/bills/{active,count,preview,run}
export const BILLS_RECALCULATION_QUERY_PARAM_KEYS = [
  "siteName",
  "provider",
  "accountNumber",
  "startDate",
  "endDate",
  "consumptionStartDateInRange",
  "siteIds",
  "areDuplicates",
  "type",
  "subtype",
  "businessUnit",
  "scope",
  "billGuid",
  "customerSiteId",
  "meterNumber",
  "measuredValue",
  "co2Emission",
  "amount",
  "addedBy",
  "isEdited",
  "isMyTask",
  "consumptionStartDate",
  "consumptionEndDate",
  "dataEntriesStatus",
  "createDate",
  "updateDate",
  "calculationMethod",
  "manuallyApproved",
  "billSuperseded",
  "estimateSource",
  "daysCovered",
] as const;

// Labels for the "Applied Filters" grid, keyed by the same backend param names sent to the recalculation endpoints.
export const BILLS_RECALCULATION_FIELD_LABELS: Record<string, string> = {
  siteName: "Site",
  provider: "Source",
  accountNumber: "Account #",
  startDate: "Start date",
  endDate: "End date",
  consumptionStartDateInRange: "Consumption start date in range",
  areDuplicates: "Show duplicate entries",
  type: "Type",
  subtype: "Sub-Type",
  businessUnit: "Business Unit",
  scope: "GHG Emission",
  billGuid: "Bill ID",
  customerSiteId: "Customer Site ID",
  meterNumber: "Meter #",
  measuredValue: "Usage",
  co2Emission: "Location Based Emissions",
  amount: "Cost",
  addedBy: "Added By",
  isEdited: "Show only edited",
  isMyTask: "Show my tasks",
  consumptionStartDate: "Consumption Start Date",
  consumptionEndDate: "Consumption End Date",
  dataEntriesStatus: "Data Entries Status",
  createDate: "Date Created",
  updateDate: "Last Modified Date",
  calculationMethod: "Calculation Method",
  manuallyApproved: "Manually Approved",
  billSuperseded: "Bill Superseded",
  estimateSource: "Estimate Source",
  daysCovered: "Number of Days",
};
